import script from "./TraCuuNhapHoc.vue?vue&type=script&lang=ts&setup=true"
export * from "./TraCuuNhapHoc.vue?vue&type=script&lang=ts&setup=true"

import "./TraCuuNhapHoc.vue?vue&type=style&index=0&id=75c804d8&lang=css"

const __exports__ = script;

export default __exports__